import { Dialog, DialogContent } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, AlertTriangle } from 'lucide-react';

export function SuccessPopup({ open, onClose, title, message, type = 'success', details = [], actionLabel, actionHandler }) {
  const config = {
    success: { icon: CheckCircle2, color: 'text-green-500', bg: 'bg-green-50', border: 'border-green-200' },
    error: { icon: XCircle, color: 'text-red-500', bg: 'bg-red-50', border: 'border-red-200' },
    warning: { icon: AlertTriangle, color: 'text-amber-500', bg: 'bg-amber-50', border: 'border-amber-200' },
  }[type] || config.success;
  const Icon = config.icon;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className={`sm:max-w-lg ${config.bg} ${config.border} border-2`} data-testid="success-popup">
        <div className="flex flex-col items-center text-center py-4">
          <div className={`rounded-full p-3 ${config.bg} mb-4`}>
            <Icon className={`h-12 w-12 ${config.color}`} strokeWidth={2} />
          </div>
          <h3 className="text-lg font-bold text-slate-800 mb-2" data-testid="popup-title">{title}</h3>
          {message && <p className="text-sm text-slate-600 mb-2">{message}</p>}
          {details && details.length > 0 && (
            <div className="w-full mt-2 mb-4 text-left max-h-48 overflow-y-auto" data-testid="popup-details">
              <ul className="space-y-1.5 px-3">
                {details.map((detail, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-slate-700 bg-white/60 rounded-md px-3 py-2 border border-slate-200">
                    <span className="text-red-400 mt-0.5 flex-shrink-0">&#9679;</span>
                    <span>{typeof detail === 'string' ? detail : (detail?.description || detail?.message || JSON.stringify(detail))}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="flex gap-2 mt-2">
            {actionLabel && actionHandler && (
              <Button onClick={actionHandler} className="px-6 bg-purple-600 hover:bg-purple-700 text-white" data-testid="popup-action-btn">
                {actionLabel}
              </Button>
            )}
            <Button onClick={onClose} variant={actionLabel ? "outline" : "default"} className="px-8" data-testid="popup-close-btn">OK</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
